import React from 'react';
import {useDispatch} from 'react-redux';
import gql from 'graphql-tag';
import {hooks} from 'lib.front';
import {logIn, loadingModal, openMsg} from 'src/redux-app';
import {validacion} from 'lib.common';
import { clientLog } from 'src/common/gqlClientes';

const logInQ = gql`
   query LogIn($user: String!, $pass: String!) {
      logIn(user: $user, pass: $pass) {
         codigo
         nombre
         apPaterno
         apMaterno
         usuario
         email
         condicion
         sucursal
         fechaVigencia
         especialidad
      }
   }
`;
export default function useLogIn(setLogResult) {
   //REDUX
   const dispatch = useDispatch();
   //CALLBACKS LOGIN
   function callbackProcesarData(data) {
      
      if (!validacion.esVarNullUndef(data)) {
         let dataAux = data[Object.keys(data)[0]];
         if (dataAux != null) {
            if (dataAux.codigo != null) {
               const fechaVigencia = new Date(dataAux.fechaVigencia);
               if (fechaVigencia > new Date()) {
                  dispatch(logIn(data.logIn));
                  setLogResult('');
               } else {
                  setLogResult('Su fecha de vigencia ha finalizado.');
               }
            } else {
               setLogResult('Usuario o Password incorrectos');
            }
         } else {
            setLogResult('Usuario o Password incorrectos');
         }
      }
   }

   function callbackLoading(loading) {
      dispatch(loadingModal(loading));
   }

   function callbackError(error) {
      dispatch(openMsg(JSON.stringify(error)));
   }

   const [loginCall] = hooks.useApolloLazyQ(
      logInQ,
      {
         callbackProcesarData: callbackProcesarData,
         callbackLoading: callbackLoading,
         callbackError: callbackError
      },
      {
         client: clientLog
      }
   );
   return loginCall;
}
